// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Header, Icon } from "semantic-ui-react";
import { getClassName } from "../../../components/utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardHeader = props => {
  const {
    content
  } = props;
  const [title, setTitle] = React.useState(content);
  const handleTitleChange = React.useCallback(e => {
    setTitle(e.target.textContent);
  }, []);
  React.useEffect(() => {
    setTitle(content);
  }, [content]);
  return /*#__PURE__*/_jsxs(Header, {
    as: "h2",
    className: getClassName("dashboard-header"),
    "data-sentry-element": "Header",
    "data-sentry-component": "DashboardHeader",
    "data-sentry-source-file": "DashboardHeader.tsx",
    children: [/*#__PURE__*/_jsx(Icon, {
      name: "dashboard",
      "data-sentry-element": "Icon",
      "data-sentry-source-file": "DashboardHeader.tsx"
    }), /*#__PURE__*/_jsx(SwitchTransition, {
      "data-sentry-element": "SwitchTransition",
      "data-sentry-source-file": "DashboardHeader.tsx",
      children: /*#__PURE__*/_jsx(CSSTransition, {
        addEndListener: (node, done) => node.addEventListener("transitionend", done, false),
        classNames: "fade",
        "data-sentry-element": "CSSTransition",
        "data-sentry-source-file": "DashboardHeader.tsx",
        children: /*#__PURE__*/_jsx(Header.Content, {
          style: {
            position: "relative"
          },
          "data-sentry-element": "unknown",
          "data-sentry-source-file": "DashboardHeader.tsx",
          children: /*#__PURE__*/_jsx("div", {
            onBlur: handleTitleChange,
            contentEditable: true,
            suppressContentEditableWarning: true,
            children: title
          })
        })
      }, content)
    })]
  });
};
export default DashboardHeader;